/* eslint-disable rally/no-non-externalized-strings */
// @ts-check
const englishUSLocale = 'en-US';
export const defaultLocaleBundle = {
  dateTimeConfiguration: {},

  language: englishUSLocale,

  locales: [englishUSLocale],

  messages: {},

  supportedLocales: [
    {
      text: 'Icelandic',
      value: 'is-IS',
    },
    {
      text: 'United States',
      value: englishUSLocale,
    },
    {
      text: 'Turkish',
      value: 'tr-TR',
    },
  ],

  supportedLanguages: [
    {
      text: 'English',
      value: englishUSLocale,
    },
    {
      text: 'Icelandic',
      value: 'is-IS',
    },
    {
      text: 'Turkish',
      value: 'tr-TR',
    },
  ],

  formats: {
    date: {
      /** @type {Intl.DateTimeFormatOptions} */
      rallyDate: {
        day: 'numeric',
        month: 'numeric',
        year: 'numeric',
      },

      /** @type {Intl.DateTimeFormatOptions} */
      rallyLongDate: {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      },

      /** @type {Intl.DateTimeFormatOptions} */
      rallyMonthTitle: {
        month: 'long',
        year: 'numeric',
      },

      /** @type {Intl.DateTimeFormatOptions} */
      rallyWeekdayShortTitle: {
        weekday: 'short',
      },
    },

    time: {
      /** @type {Intl.DateTimeFormatOptions} */
      rallyDateTime: {
        day: 'numeric',
        month: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        timeZoneName: 'short',
      },
    },
  },
};

export const defaultLocale = englishUSLocale;
